// extracted by mini-css-extract-plugin
export var author = "menuProducts-module--author--f3e92";
export var benefits = "menuProducts-module--benefits--83ffd";
export var category = "menuProducts-module--category--2453f";
export var ctaButton = "menuProducts-module--ctaButton--59fd7";
export var ctaParagraph = "menuProducts-module--ctaParagraph--c9772";
export var headline = "menuProducts-module--headline--f5fb4";
export var headlinePost = "menuProducts-module--headline-post--ddf99";
export var itemsCol = "menuProducts-module--itemsCol--645fe";
export var itemsWrapper = "menuProducts-module--itemsWrapper--a899b";
export var lastCol = "menuProducts-module--lastCol--678eb";
export var paragraph = "menuProducts-module--paragraph--0842b";
export var secondaryArea = "menuProducts-module--secondaryArea--e0d4f";
export var teamImage = "menuProducts-module--teamImage--9f88f";